import axios from "axios";

const baseURL =
  process.env.VUE_APP_CONSULTA_IVERTEX_URL ||
  "https://api.grupoparque.com.br/api-consulta-ivertex/";

const httpOpen = axios.create({
  baseURL: baseURL.replace(/\/?$/, "/") + "apiopen/",
  timeout: 120000,
});

export default {
  listar: () => httpOpen.get("lista_carne"),
};
